import { IconPropsType } from '..';

export const AnnouncementIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.4141 11.5412V16.3334C17.4141 16.6684 17.2248 16.9397 16.8084 16.9397C16.7077 16.9397 16.4582 16.7249 16.1517 16.4014V3.53834C16.4582 3.21485 16.7077 3 16.8084 3C17.2624 3 17.4141 3.27129 17.4141 3.60571V8.51932C18.2353 8.54238 19 9.20817 19 10.0299C19 10.8523 18.2353 11.5181 17.4141 11.5412ZM7.667 12.7095C7.70463 12.7095 7.667 7.22962 7.667 7.22962C11.8286 7.22962 14.2958 5.40279 15.5958 4.15011V15.789C14.2958 14.5369 11.8286 12.7095 7.667 12.7095ZM5.24297 17.5078L4.03095 12.6967H2.81833C2.81833 12.6967 2.45782 11.8786 2.29395 10.8784C1.98503 10.8784 1.71495 10.8784 1.60571 10.8784C1.27129 10.8784 1 10.6071 1 10.2721V9.6664C1 9.33138 1.27129 9.06009 1.60571 9.06009C1.71495 9.06009 1.98503 9.06009 2.29395 9.06009C2.45843 8.05988 2.81833 7.24236 2.81833 7.24236H7.06069V12.6967H5.84868L6.00162 13.3024H6.60672L6.90957 14.5151H6.30629L7.06069 17.5078H5.24297Z"
      fill="currentColor"
    />
  </svg>
);
